// Live Google Play listing (TWA wrapper of the PWA).
// NOTE: the old `gg.teamplay.app` id is dead (returns 404) — always use this one.
//
// Untagged on purpose, and only the update gate should use it: it prompts people who
// ALREADY have the app, so a utm on it would show up in Play Console acquisition and
// inflate whichever channel it was attributed to. Everything that invites a NEW install
// goes through `playStoreUrl(source)` in `#features/app-install` instead.
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=gg.teamplay.twa';
